// @generated by tools/docgen — do not edit.
// Source: docs/examples/static_queryset.md

import React from 'react';
import { StaticQuerysetDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function StaticQuerysetPage() {
  return (
    <ExampleLayout title="Static queryset" demo={<StaticQuerysetDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          tasks is a bare Django queryset assigned once in on_connect to a many=True rx.model field -- that one assignment is the whole declaration. The client keeps the list correct on its own: rows are filtered by the queryset's conditions and sorted by its ordering, re-evaluated live as updates arrive. Toggling a task's status flips it out of (or back into) the list; raising its priority re-sorts it; deleting it removes it. One deliberate limitation: a task created after the snapshot appears only when the field is rebound -- for lists where new rows arrive live, see <a href={`${process.env.PUBLIC_URL || ''}/examples/task_board`} className="text-primary-700 hover:underline">Task board</a>.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-static-queryset-backend">
        <ExampleSectionHeading id="examples-static-queryset-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="static_queryset/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-static-queryset-models">
        <ExampleSectionHeading id="examples-static-queryset-models">
          Models
        </ExampleSectionHeading>
        <SourceFile path="static_queryset/models.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-static-queryset-serializers">
        <ExampleSectionHeading id="examples-static-queryset-serializers">
          Serializers
        </ExampleSectionHeading>
        <SourceFile path="static_queryset/serializers.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-static-queryset-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-static-queryset-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="static_queryset/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default StaticQuerysetPage;
